import React from "react";

const PRIVACY_URL = "https://portal.myemployeesfirst.com/_Main/PrivacyPolicy";
const TERMS_URL = "https://portal.myemployeesfirst.com/_Main/TermsConditions";

export default function EmployerLegalFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="border-t px-6 py-5 text-center text-xs"
      style={{ borderColor: "var(--border)", color: "var(--muted)" }}
      data-testid="employer-legal-footer"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-legal-link font-semibold"
            style={{ color: "var(--ink)" }}
            data-testid="footer-privacy-link"
          >
            Privacy Notice
          </a>
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-legal-link font-semibold"
            style={{ color: "var(--ink)" }}
            data-testid="footer-terms-link"
          >
            Terms &amp; Conditions
          </a>
        </div>
        <div className="mt-2" data-testid="footer-copyright">© {year} Employees First, Inc.</div>
      </div>
    </footer>
  );
}